var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBtnCreate = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 8.192a3.808 3.808 0 0 1 3.808-3.808h6.217a1.038 1.038 0 1 1 0 2.077H7.308c-.956 0-1.731.775-1.731 1.73v9.001c0 .956.775 1.731 1.73 1.731h9.001c.956 0 1.731-.775 1.731-1.73v-6.235a1.038 1.038 0 1 1 2.077 0v6.234A3.808 3.808 0 0 1 16.308 21h-9A3.808 3.808 0 0 1 3.5 17.192v-9Zm17.696-4.888a1.038 1.038 0 0 1 0 1.467L10.811 15.164l-1.772.297.304-1.765L19.73 3.304a1.039 1.039 0 0 1 1.467 0Z",
  fill: "#fff"
})));

export { SvgBtnCreate as ReactComponent };
export default __webpack_public_path__ + "static/media/btn-create.4a7072a3.svg";